import { render, staticRenderFns } from "./AuditTrailList.vue?vue&type=template&id=52155048&scoped=true"
import script from "./AuditTrailList.vue?vue&type=script&lang=js"
export * from "./AuditTrailList.vue?vue&type=script&lang=js"
import style0 from "./AuditTrailList.vue?vue&type=style&index=0&id=52155048&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52155048",
  null
  
)

export default component.exports